import ThankyouMobile from './ThankyouMobile';
import ThankyouDesktop from './ThankyouDesktop';
import { connect } from 'react-redux';
import { isMobileOrTablet } from '../lib/utils';

const mapStateToProps = (state, ownProps) => ({
  recipientRequestId: ownProps.recipientRequestId || state.recipientRequestId,
  caseName: state.caseName,
  companyName: state.companyName,
  companyEmail: state.companyEmail,
  companyLogo: state.companyLogo,
  brandingDetails: state.brandingDetails
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(isMobileOrTablet() ? ThankyouMobile : ThankyouDesktop);
